import { useEditor, track } from 'tldraw';

import { clearNonCoreShapes } from '../../timelineDrawingHelpers';
import { Icon } from '@/new/components/icon';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/new/components/shadcn/tooltip';

export const ClearButton = track(() => {
  const editor = useEditor();

  const handleClear = () => {
    if (!editor) return;
    clearNonCoreShapes(editor);
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          className="flex cursor-pointer rounded-md border border-gray-100 p-2 shadow-sm transition-colors hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
          onClick={handleClear}
        >
          <Icon className="lucide--eraser h-4 w-4" />
        </button>
      </TooltipTrigger>
      <TooltipContent>Clear notes</TooltipContent>
    </Tooltip>
  );
});
